<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>激活与绑卡</el-breadcrumb-item>
      <el-breadcrumb-item>绑卡信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="container">
      <el-radio-group v-model="radioCycle" style="margin-right: 20px; " size="medium">
        <el-radio-button label="weekly">weekly</el-radio-button>
        <el-radio-button label="monthly">monthly</el-radio-button>
      </el-radio-group>

      <el-radio-group v-model="radioType" style="margin-right: 20px; " size="medium">
        <el-radio-button label="pad">pad</el-radio-button>
        <el-radio-button label="app">app</el-radio-button>
        <el-radio-button label="all">all</el-radio-button>
        <el-radio-button label="xbike">xbike</el-radio-button>
        <el-radio-button label="litbike">litbike</el-radio-button>
        <el-radio-button label="boombike">boombike</el-radio-button>
        <el-radio-button label="boombasic">boombasic</el-radio-button>
        <el-radio-button label="ebike">ebike</el-radio-button>
        <el-radio-button label="other">other</el-radio-button>
      </el-radio-group>

      <el-button type="primary" @click="exportCsv" style="margin-left: 20px;  ">下载CSV</el-button>


    </div>


    <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'title', order: 'descending' }">
      <el-table-column prop="title" label="日期" width="185" sortable>
      </el-table-column>
      <el-table-column prop="activate_count" label="本周期激活">
      </el-table-column>
      <el-table-column prop="bound_count" label="绑卡数量">
      </el-table-column>
      <el-table-column prop="today_bound_count" label="当天绑卡">
      </el-table-column>
      <el-table-column prop="recall_bound_count" label="召回绑卡">
      </el-table-column>



      <el-table-column prop="balance" label="平衡">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColorBad(scope.row.balance) }">{{ scope.row.balance }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="activate_and_bound" label="激活并绑卡">
      </el-table-column>

      <el-table-column label="当周期绑卡率">
        <template slot-scope="scope">
          <span>{{ scope.row.activate_total === 0 ? '-' : ((scope.row.activate_and_bound / scope.row.activate_count *
        100).toFixed(2) + '%') }}</span>
        </template>
      </el-table-column>



      <el-table-column prop="activate_total" label="累计激活">
      </el-table-column>
      <el-table-column prop="bound_total" label="累计绑卡">
      </el-table-column>


      <el-table-column prop="unbound_total" label="累计未绑卡">
      </el-table-column>

      <el-table-column prop="days30" label="其中30天内">
      </el-table-column>
      <el-table-column prop="days180" label="31-180天">
      </el-table-column>
      <el-table-column prop="days181" label="181天以上">
      </el-table-column>

      <el-table-column prop="unbound_device" label="至今未绑卡试用的设备清单" width="480">

        <template v-slot="scope">
    <span v-if="scope.row.unbound_device && scope.row.unbound_device.length > 0">
      <!-- 设备数量少于10个的情况 -->
      <div v-if="scope.row.unbound_device.length < 8"   class="device-number-link">
        <a href="javascript:;"
           v-for="(device, index) in scope.row.unbound_device"
           :key="index"
           @click.prevent="openDeviceDetails(device)">
          {{ device }}
        </a>
        <!-- 添加逗号分隔 -->
        <template v-if="index < scope.row.unbound_device.length - 1">, </template>
      </div>

      <!-- 设备数量多于或等于10个的情况 -->
      <div v-else      class="device-number-link">
        <!-- 当 showMore 为 false 时，显示缩略文本和查看全部链接 -->
        <span v-if="!scope.row.showMore">
          <a href="javascript:;"
             v-for="(device, index) in scope.row.unbound_device.slice(0, 7)"
             :key="index"
             @click.prevent="openDeviceDetails(device)">
            {{ device }}
          </a>
          <!-- 添加省略号和查看全部链接 -->
          <span>...</span>
          <a href="javascript:;" @click.prevent="toggleShowMore(scope.row.id)">查看全部</a>
        </span>
        
        <!-- 当 showMore 为 true 时，显示全部文本和收起链接 -->
        <span v-else>
          <a href="javascript:;"
             v-for="(device, index) in scope.row.unbound_device"
             :key="index"
             @click.prevent="openDeviceDetails(device)">
            {{ device }}
          </a>
          <a href="javascript:;" @click.prevent="toggleShowMore(scope.row.id)">收起</a>
        </span>
      </div>
    </span>
    <span v-else>-</span>
  </template>



      </el-table-column> 

    </el-table>




  </div>
</template>

<script>

import { exportToCsv } from '@/utils/exportToCsv';

export default {
  data() {
    return {
      tableData: [],
      radioCycle: 'weekly',
      radioType: 'pad',
    }
  },
  watch: {
    radioCycle(newVal, oldVal) {

      this.getData()
    },

    radioType(newVal, oldVal) {
      this.getData()
    },
  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods: {
    async getData() {
      //const bike_type = type;
      this.tableData = []

      let res = await this.$http.get("/da/activate_and_binding/" + this.radioCycle + "/" + this.radioType)
      this.tableData = res.data;
      this.tableData.forEach(row => {
        this.$set(row, 'showMore', false);
      });
      //console.log(res.data)
    },
    exportCsv() {
      let fileName = "ActivateAndBinding_" + "_" + this.radioCycle + this.radioType
      exportToCsv(this.tableData, fileName)
    },

    getBalanceColorBad(value) {
      if (value < -0.1) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= -0.1 && value < 0.1) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },
    toggleShowMore(id) {
    const item = this.tableData.find(dataItem => dataItem.id === id);
    if (item) {
      item.showMore = !item.showMore;
    }
  },
  openDeviceDetails(deviceNumber) {
    const routeData = this.$router.resolve({
    name: 'deviceInfo',
    query: { deviceNumber: deviceNumber.trim() } // 使用查询参数传递 deviceNumber
  });
  // 在新窗口中打开URL
  window.open(routeData.href, '_blank');
},

  },

  mounted: function () {
    //注意回调函数的作用域!!!
    this.getData()
  }
}
</script>


<style scoped>
.container {

  display: flex;
  justify-content: flex-end;
  width: 93%;

  margin-bottom: 20px;
}
.device-number-link a {
    color: blue; /* 鼠标悬停时变为蓝色 */
  text-decoration: none; /* 移除下划线 */
}

.device-number-link a:hover {
  color: #ffaa00; /* 点击时变为海思蓝色 */
}

.device-number-link a:active {
  color: inherit; /* 正常状态下使用继承的颜色，即没有特别的颜色 */

}
</style>